// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"689fc3cb","199":"ad4cdd96","496":"142acfea"}[chunkId] + ".chunk.js";
};